export const download = (
  url: string,
  fileName?: string,
  openInNewTab = true,
) => {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName ?? ''
  if (openInNewTab) {
    a.target = '_blank'
  }
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
